export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/account',
    name: '/account',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/account.vue'),
    /* no children */
  },
  {
    path: '/actions',
    /* internal name: '/actions' */
    /* no component */
    children: [
      {
        path: ':actionType',
        /* internal name: '/actions/[actionType]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/actions/[actionType]/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/actions/[actionType]/index.vue'),
            /* no children */
          },
          {
            path: 'categories',
            /* internal name: '/actions/[actionType]/categories' */
            /* no component */
            children: [
              {
                path: ':categorySlug',
                name: '/actions/[actionType]/categories/[categorySlug]',
                component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/actions/[actionType]/categories/[categorySlug].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/auction',
    name: '/auction',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/auction.vue'),
    /* no children */
  },
  {
    path: '/basket',
    name: '/basket',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/basket.vue'),
    /* no children */
  },
  {
    path: '/become-partner',
    /* internal name: '/become-partner' */
    /* no component */
    children: [
      {
        path: '',
        name: '/become-partner/',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/become-partner/index.vue'),
        /* no children */
        meta: {
          "layout": "auth"
        }
      },
      {
        path: 'error',
        /* internal name: '/become-partner/error' */
        /* no component */
        children: [
          {
            path: '',
            name: '/become-partner/error/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/become-partner/error/index.vue'),
            /* no children */
            meta: {
              "layout": "auth"
            }
          },
          {
            path: 'not-identified-company',
            name: '/become-partner/error/not-identified-company',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/become-partner/error/not-identified-company.vue'),
            /* no children */
          },
          {
            path: 'verify',
            name: '/become-partner/error/verify',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/become-partner/error/verify.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'success',
        /* internal name: '/become-partner/success' */
        /* no component */
        children: [
          {
            path: '',
            name: '/become-partner/success/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/become-partner/success/index.vue'),
            /* no children */
            meta: {
              "layout": "auth"
            }
          }
        ],
      }
    ],
  },
  {
    path: '/brands',
    /* internal name: '/brands' */
    /* no component */
    children: [
      {
        path: ':brandId',
        /* internal name: '/brands/[brandId]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/brands/[brandId]/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/brands/[brandId]/index.vue'),
            /* no children */
          },
          {
            path: 'categories',
            /* internal name: '/brands/[brandId]/categories' */
            /* no component */
            children: [
              {
                path: ':categorySlug',
                name: '/brands/[brandId]/categories/[categorySlug]',
                component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/brands/[brandId]/categories/[categorySlug].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/catalog',
    /* internal name: '/catalog' */
    /* no component */
    children: [
      {
        path: '',
        name: '/catalog/',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/catalog/index.vue'),
        /* no children */
      },
      {
        path: ':slug',
        name: '/catalog/[slug]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/catalog/[slug].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/change-password',
    name: '/change-password',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/change-password.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/compare',
    name: '/compare',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/compare.vue'),
    /* no children */
  },
  {
    path: '/confirm-order',
    /* internal name: '/confirm-order' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/confirm-order/[id]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/confirm-order/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/create-offer',
    name: '/create-offer',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/create-offer.vue'),
    /* no children */
  },
  {
    path: '/create-password',
    name: '/create-password',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/create-password.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/cto-apple',
    /* internal name: '/cto-apple' */
    /* no component */
    children: [
      {
        path: ':slug',
        name: '/cto-apple/[slug]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/cto-apple/[slug].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dep',
    /* internal name: '/dep' */
    /* no component */
    children: [
      {
        path: 'enrollments',
        /* internal name: '/dep/enrollments' */
        /* no component */
        children: [
          {
            path: '',
            name: '/dep/enrollments/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/dep/enrollments/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/dep/enrollments/[id]',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/dep/enrollments/[id].vue'),
            /* no children */
          },
          {
            path: 'devices',
            /* internal name: '/dep/enrollments/devices' */
            /* no component */
            children: [
              {
                path: '',
                name: '/dep/enrollments/devices/',
                component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/dep/enrollments/devices/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/forgot-password',
    name: '/forgot-password',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/forgot-password.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/orders',
    /* internal name: '/orders' */
    /* no component */
    children: [
      {
        path: '',
        name: '/orders/',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/orders/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/orders/[id]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/orders/[id].vue'),
        /* no children */
      },
      {
        path: 'history',
        /* internal name: '/orders/history' */
        /* no component */
        children: [
          {
            path: '',
            name: '/orders/history/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/orders/history/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'open',
        /* internal name: '/orders/open' */
        /* no component */
        children: [
          {
            path: '',
            name: '/orders/open/',
            component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/orders/open/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/otp-login',
    name: '/otp-login',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/otp-login.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/personal-settings',
    name: '/personal-settings',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/personal-settings.vue'),
    /* no children */
  },
  {
    path: '/product',
    /* internal name: '/product' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/product/[id]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/product/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/promotion',
    /* internal name: '/promotion' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/promotion/[id]',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/promotion/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reset-password',
    name: '/reset-password',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/reset-password.vue'),
    /* no children */
    meta: {
      "layout": "auth"
    }
  },
  {
    path: '/service-centers',
    name: '/service-centers',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/service-centers.vue'),
    /* no children */
  },
  {
    path: '/warranty',
    name: '/warranty',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/warranty.vue'),
    children: [
      {
        path: 'check-status',
        name: '/warranty/check-status',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/warranty/check-status.vue'),
        /* no children */
      },
      {
        path: 'create-rma',
        name: '/warranty/create-rma',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/warranty/create-rma.vue'),
        /* no children */
      },
      {
        path: 'history',
        name: '/warranty/history',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/warranty/history.vue'),
        /* no children */
      },
      {
        path: 'processing',
        name: '/warranty/processing',
        component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/warranty/processing.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/xml-exchange',
    name: '/xml-exchange',
    component: () => import('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/B2B/B2B_Deploy_Prod/src/app/pages/xml-exchange.vue'),
    /* no children */
  }
]
